import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';
import { RootState } from '../../domain/models/RootState';
import { createAsyncThunkApp } from '../hooks';

export const createLoan = createAsyncThunk<any, any, { state: RootState }>(
  'Loan/createLoan',
  async (loan: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res = await API.createLoan(auth.token, loan);
      if (res.status === 200) {
        Swal.fire('Correcto', 'Se agrego el prestamo correctamente', 'success');
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al agregar el prestamo',
        text: 'Por favor, intenta de nuevo',
      });
      throw error;
    }
  }
);

export const loanRepayment = createAsyncThunk<any, any, { state: RootState }>(
  'Loan/createLoan',
  async (loan: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res = await API.loanRepayment(auth.token, loan);
      if (res.status === 200) {
        Swal.fire('Correcto', 'Se hizo la devolucion correctamente', 'success');
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al gestionar el prestamo',
        text: 'Por favor, intenta de nuevo',
      });
      throw error;
    }
  }
);

export const getAllLoans = createAsyncThunk<any, any, { state: RootState }>(
  'Loans/getAllLoans',
  async ({ filter, pagination }: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const filterTmp =
        auth.type == 3 ? `&users_id=${auth.id}${filter}` : filter;
      return await API.getAllLoans(auth.token, filterTmp, pagination);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const getUserLoan = createAsyncThunkApp<any, string>(
  'Loans/getUserLoan',
  async (filter: string, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res: any = await API.getUserLoan(auth.token, filter);
      return res.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos del usuario',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const getSessionLoans = createAsyncThunkApp<any, void>(
  'Loans/getSessionLoans',
  async (_: void, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res: any = await API.getSessionLoans(auth.token);
      return res.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos del usuario',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);
